<picture>
  <source *ngFor="let item of sources" sizes="{{item.sizes}}" srcset="{{item.srcset}}" type="{{item.type}}">
  <img [class]="cssClass" src="{{src}}" alt="{{alt}}" [attr.loading]="loading" draggable="false"/>
</picture>